<script>
    import bannerImage from '../../assets/img/banner.png';
    import ipv6Image from '../../assets/img/ipv.png';
    import NormalDropDown from './NormalDropDown.vue';

    export default {
        name: 'CommonHeader',
        components: {NormalDropDown},
        props: {
            //背景图
            background: {
                type: String,
                required: false,
                default: bannerImage
            },
            // 左上角链接
            link: {
                type: String,
                required: false,
                default: ''
            },
            //左上角名称
            name: {
                type: String,
                required: false,
                default: ''
            },
            // 链接打开方式
            target: {
                type: String,
                required: false,
                default: '_self'
            },
            // 链接旁边的icon
            icon: {
                type: String,
                required: false,
                default: ''
            },
            //IPV6图标
            ipv6Image: {
                type: String,
                required: false,
                default: ipv6Image
            },
            isHasIpv6: {
                type: Boolean,
                required: false,
                default: true
            },
            // 右上角按钮，'fav','login', 'search'
            actions: {
                default () {
                    return [];
                },
                required: false
            },
            // 是否收藏
            isFav: {
                type: Boolean,
                required: false,
                default: false
            },
            userName: {
                type: String,
                required: false,
                default: ''
            },
            options: {
                default () {
                    return [];
                },
                required: false
            },
        },
        computed: {
            compName () {
                return `${ this.icon }${ this.name }`;
            },
            compStyle () {
                return {
                    'backgroundImage': `url(${ this.background })`
                };
            },
            opts () {
                return this.options.length ? this.options.length : [
                    {
                        text: '个人中心',
                        value: 'personal'
                    },
                    {
                        text: '退出登录',
                        value: 'logout'
                    }
                ];
            }
        },
        methods: {
            handleClick ($e) {
                this.$emit('btn:click', $e);
            },
            handleOpt ($e) {
                this.$emit('opt:change', $e);
            }
        }
    };
</script>

<template>
    <div class="southcn-common-header" :style="compStyle">
        <div class="southcn-common-header__top">
            <a :href="link" :target="target" class="southcn-common-header__name" v-html="compName"></a>
            <div class="southcn-common-header__top--right">
                <div class="southcn-common-header__btn"
                     @click="handleClick('search')"
                     v-if="actions.includes('search')">
                    <span class="southcn-common-header__btn-icon">&#xe821;&nbsp;</span>
                </div>
                <div class="southcn-common-header__btn"
                     @click="handleClick('myfav')"
                     v-if="actions.includes('fav') && isFav">
                    <span class="southcn-common-header__btn-text">我的收藏</span>
                </div>
                <div class="southcn-common-header__btn"
                     @click="handleClick('unfav')"
                     v-if="actions.includes('fav') && isFav">
                    <span class="southcn-common-header__btn-icon" style="color: #f9a825;">&#xe640;&nbsp;</span>
                    <span class="southcn-common-header__btn-text">已收藏</span>
                </div>
                <div class="southcn-common-header__btn"
                     @click="handleClick('fav')"
                     v-if="actions.includes('fav') && !isFav">
                    <span class="southcn-common-header__btn-icon">&#xe784;&nbsp;</span>
                    <span class="southcn-common-header__btn-text">收藏</span>
                </div>
                <div class="southcn-common-header__btn"
                     @click="handleClick('login')"
                     v-if="actions.includes('login') && !userName">
                    <span class="southcn-common-header__btn-icon">&#xe805;&nbsp;</span>
                    <span class="southcn-common-header__btn-text">登录</span>
                </div>
                <normal-drop-down :options="opts"
                                  :text="userName"
                                  @change="handleOpt"
                                  v-else-if="actions.includes('login') && userName"/>
            </div>
        </div>
        <div class="southcn-common-header__content">
            <!--页头具体内容-->
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .southcn-common-header {
        .px2rem(height, 307);
        width: 100%;
        box-sizing: border-box;
        position: relative;
        background-repeat: no-repeat;
        background-size: 100% 4.09rem;

        &__btn {
            display: flex;
            align-items: center;
            .px2rem(padding-right, 15);
            .px2rem(padding-left, 15);
            color: @whiteBg;

            &-icon {
                font-family: cmsicon;
                .px2rem(height, 88);
                .px2rem(line-height, 88);
                .px2rem(font-size, 36);
            }

            &-text {
                .px2rem(font-size, 28);
            }
        }

        &__top {
            .px2rem(height, 88);
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(255, 255, 255, .3);
            justify-content: space-between;

            &--right {
                display: flex;
                align-items: center;
            }
        }

        &__content {
            .px2rem(height, 218);
            display: flex;
            align-items: center;
        }

        &__name {
            display: flex;
            overflow: hidden;
            margin-left: 0.3125rem;
            align-items: center;
            font-family: cmsicon;
            font-size: 0.34666667rem;
            font-weight: bold;
            text-decoration: none;
            color: @whiteBg;
        }

        &__ipv6 {
            width: 1.28rem;
            right: 0.156255rem;
            position: absolute;
            top: 0.3rem;
        }
    }
</style>
